module.exports = __webpack_public_path__ + "static/media/LAVA.75040afe.png";